import { Card, CARD_THEME } from '@st-operations/uikit/src/v2/index.js'
import React, { useState, useEffect } from 'react'

import { logErrorAsync } from '_lib/utility'
import { getTopDomains, getDistribution } from '_services/data-explorer'
import { useEventFeedsContext } from '../../../context/index.jsx'
import { useIsSnapshot } from '../../../manage-component/index.jsx'
import DomainsCard from './domains-card/index.jsx'

import '../styles.scss'

const TopDomains = () => {
  const [topDomains, setTopDomains] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [totalEvents, setTotalEvents] = useState(0)
  const { data, id } = useEventFeedsContext()
  const isSnapshot = useIsSnapshot()

  useEffect(() => {
    const getData = async () => {
      if (data._id || id === 'discovery') {
        if (isSnapshot) {
          setTopDomains(data.snapshot.topDomains.topDomains)
          setTotalEvents(data.snapshot.topDomains.totalEvents)
          return
        }

        try {
          const requestConfig = {
            attributes: data.attributes,
            filters: data.filters,
            aggregations: data.aggregations,
          }

          setIsLoading(true)
          const response = await getTopDomains(requestConfig)
          const distributions = await getDistribution(requestConfig)
          setTopDomains(response.topDomains || [])
          setTotalEvents(distributions.totalEvents)
        } catch (error) {
          logErrorAsync(error)
          toast.error(error.message)
        }
        setIsLoading(false)
      }
    }

    getData()
  }, [data.filters])

  return (
    <section className="scale-and-coverage__container">
      <div className="data-preview-highlights">
        <Card
          className="data-preview-highlights__main-card"
          style={{ paddingTop: 55 }}
          theme={CARD_THEME.NO_SHADOW}
        >
          <div className="data-preview-highlights__main-card-title highlights-domains-table__title">
            <h2>Top Domains</h2>
          </div>
          <DomainsCard isLoading={isLoading} topDomains={topDomains} totalEvents={totalEvents} />
        </Card>
      </div>
    </section>
  )
}

export default TopDomains
